
<template>
  <div class="CJGG_HX">
    <div class="title">
      {{
        detail.cityName +
          detail.townName +
          detail.deptName +
          detail.projectName || "/"
      }}项目成交公告
    </div>
    <div class="content">
      <table border="1" style="border-color: #bbdbea; width: 100%">
        <tr style="display: flex">
          <td class="table_title">项目名称:</td>
          <td
            class="table_content1"
            :title="
              detail.townName + detail.deptName + detail.projectName || '/'
            "
          >
            {{ detail.townName + detail.deptName + detail.projectName || "/" }}
          </td>
          <td class="table_title">项目编号:</td>
          <td class="table_content2" :title="detail.projectNumber || '/'">
            {{ detail.projectNumber || "/" }}
          </td>
        </tr>
        <tr style="display: flex">
          <td class="table_title">交易方式:</td>
          <td
            class="table_content1"
            :title="
              (detail.type == 1 && '竞拍成交') ||
              (detail.type == 2 && '协议成交') ||
              '/'
            "
          >
            {{
              (detail.type == 1 && "竞拍成交") ||
              (detail.type == 2 && "协议成交") ||
              "/"
            }}
          </td>
          <td class="table_title">数量:</td>
          <td
            class="table_content2"
            :title="
              detail.area
                ? detail.area + getDictValue(detail.areaUnit, 'area_unit')
                : '/'
            "
          >
            {{
              detail.area
                ? detail.area + getDictValue(detail.areaUnit, "area_unit")
                : "/"
            }}
          </td>
        </tr>
        <tr style="display: flex">
          <td
            class="table_title"
            :title="
              (detail.projectType == 2 && '项目底价:') ||
              (detail.projectType == 3 && '最高限价:') ||
              '/'
            "
          >
            {{
              (detail.projectType == 2 && "项目底价:") ||
              (detail.projectType == 3 && "最高限价:") ||
              "/"
            }}
          </td>
          <td
            class="table_content1"
            :title="detail.initPrice ? detail.initPrice + '元' : '/'"
          >
            {{ detail.initPrice ? detail.initPrice + "元" : "/" }}
          </td>
          <td class="table_title">成交价格:</td>
          <td
            class="table_content2"
            :title="
              detail.transactionprice ? detail.transactionprice + '元' : '/'
            "
          >
            {{ detail.transactionprice ? detail.transactionprice + "元" : "/" }}
          </td>
        </tr>
        <tr style="display: flex">
          <td
            class="table_title"
            :title="
              (detail.projectType == 2 && '转出方:') ||
              (detail.projectType == 3 && '需求方:') ||
              '/'
            "
          >
            {{
              (detail.projectType == 2 && "转出方:") ||
              (detail.projectType == 3 && "需求方:") ||
              "/"
            }}
          </td>
          <td
            class="table_content1"
            :title="detail.outName ? detail.outName : '/'"
          >
            {{ detail.outName || "/" }}
          </td>
          <td class="table_title">成交方:</td>
          <td
            class="table_content2"
            :title="detail.assignee ? detail.assignee : '/'"
          >
            {{ detail.assignee || "/" }}
          </td>
        </tr>
        <tr style="display: flex">
          <td class="table_title">成交时间:</td>
          <td class="table_content1" :title="detail.dealtime || '/'">
            {{ detail.dealtime || "/" }}
          </td>
        </tr>
        <tr style="display: flex">
          <td class="table_title">转出期限:</td>
          <td
            class="table_content1"
            :title="
              Math.ceil(
                detail.outStartTime &&
                  detail.outEndTime &&
                  ((Number(detail.outEndTime.split('-')[0]) -
                    Number(detail.outStartTime.split('-')[0])) *
                    12 +
                    Number(detail.outEndTime.split('-')[1]) -
                    Number(detail.outStartTime.split('-')[1]) +
                    Number(
                      (
                        (Number(detail.outEndTime.split('-')[2]) -
                          Number(detail.outStartTime.split('-')[2])) /
                        30
                      ).toFixed(2)
                    )) /
                    12
              )
                ? Math.ceil(
                    detail.outStartTime &&
                      detail.outEndTime &&
                      ((Number(detail.outEndTime.split('-')[0]) -
                        Number(detail.outStartTime.split('-')[0])) *
                        12 +
                        Number(detail.outEndTime.split('-')[1]) -
                        Number(detail.outStartTime.split('-')[1]) +
                        Number(
                          (
                            (Number(detail.outEndTime.split('-')[2]) -
                              Number(detail.outStartTime.split('-')[2])) /
                            30
                          ).toFixed(2)
                        )) /
                        12
                  ) + '年'
                : '/'
            "
          >
            {{
              Math.ceil(
                detail.outStartTime &&
                  detail.outEndTime &&
                  ((Number(detail.outEndTime.split("-")[0]) -
                    Number(detail.outStartTime.split("-")[0])) *
                    12 +
                    Number(detail.outEndTime.split("-")[1]) -
                    Number(detail.outStartTime.split("-")[1]) +
                    Number(
                      (
                        (Number(detail.outEndTime.split("-")[2]) -
                          Number(detail.outStartTime.split("-")[2])) /
                        30
                      ).toFixed(2)
                    )) /
                    12
              )
                ? Math.ceil(
                    detail.outStartTime &&
                      detail.outEndTime &&
                      ((Number(detail.outEndTime.split("-")[0]) -
                        Number(detail.outStartTime.split("-")[0])) *
                        12 +
                        Number(detail.outEndTime.split("-")[1]) -
                        Number(detail.outStartTime.split("-")[1]) +
                        Number(
                          (
                            (Number(detail.outEndTime.split("-")[2]) -
                              Number(detail.outStartTime.split("-")[2])) /
                            30
                          ).toFixed(2)
                        )) /
                        12
                  ) + "年"
                : "/"
            }}
          </td>
        </tr>
        <tr style="display: flex">
          <td class="table_title">标的区域:</td>
          <td
            class="table_content1"
            :title="detail.projectAddress ? detail.projectAddress : '/'"
          >
            {{ detail.projectAddress || "/" }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { getPublicityDetail } from '../api/mian'
import { getTypeList } from '../api/交易项目详情'

export default {
  data () {
    return {
      detail: {},
      dictList: {
        // 单位
        "area_unit": [],
      }
    }
  },
  created () {
    getPublicityDetail({ id: this.$route.query.remark }).then(res => {
      this.detail = res.data.data
      console.log("成交公告详情信息", this.detail)
    })
    for (let dictTitle of Object.keys(this.dictList)) {
      getTypeList(dictTitle).then(res => {
        this.dictList[dictTitle] = res.data.data
      })
    }

  },
  mounted () { },
  computed: {},
  watch: {},
  methods: {
    // 获取字典值
    getDictValue (value, dictTitle) {
      if ((value !== 0 && value !== '0') && !value) return "暂无"
      return this.dictList[dictTitle].find((item) => item.dictValue == value) ? this.dictList[dictTitle].find((item) => item.dictValue == value).dictLabel : "暂无"
    },
  },
};
</script>
<style scoped lang="scss">
.CJGG_HX {
  width: 1420px;
  height: auto;
  margin: 0 auto;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
  padding: 41px 200px 60px 200px;
  min-height: 500px;
  .title {
    width: 100%;
    height: auto;
    font-size: 36px;
    text-align: center;
    margin-bottom: 20px;
  }
  .content {
    width: 100%;
    height: auto;
    .table_title {
      text-align: center;
      background-color: #e1f5ff;
      width: 200px;
      height: 70px;
      line-height: 70px;
      font-size: 24px;
      border: 1px solid #bbdbea;
    }
    .table_content1 {
      text-align: center;
      flex: 2.5;
      height: 70px;
      line-height: 70px;
      border: 1px solid #bbdbea;
      font-size: 20px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .table_content2 {
      text-align: center;
      flex: 1;
      height: 70px;
      line-height: 70px;
      border: 1px solid #bbdbea;
      font-size: 20px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
</style>